const KEY = 'demodeck.lastSession.v1';

export function loadSession() {
    try {
        const raw = localStorage.getItem(KEY);
        if (!raw) return {};
        return JSON.parse(raw) || {};
    } catch {
        return {};
    }
}

export function saveSession(patch) {
    try {
        const current = loadSession();
        const next = { ...current, ...patch };
        localStorage.setItem(KEY, JSON.stringify(next));
    } catch {
        // localStorage full / disabled — silently ignore
    }
}

export function clearSession() {
    try { localStorage.removeItem(KEY); } catch {}
}
